var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.09 19.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000032;stroke-miterlimit:10;}.cls-2{fill:#000032;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sort_Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rswAgG.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.44,15.58c.11-.11.18-.16.24-.23.71-.7,1.41-1.42,2.12-2.12a1,1,0,0,1,1.75.43,1,1,0,0,1-.25,1c-1.39,1.39-2.78,2.79-4.17,4.17a1,1,0,0,1-1.44,0q-2.07-2.05-4.11-4.12A1,1,0,0,1,12,13.27l2.11,2.11.22.21v-14a1,1,0,1,1,2.07,0c0,1.55,0,3.1,0,4.65v9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.16,4V18a1,1,0,1,1-2.07,0v-14l-.22.2L1.81,6.3A1,1,0,1,1,.36,4.83l4-4a1,1,0,0,1,1.6,0l4,4a1,1,0,0,1,0,1.51,1,1,0,0,1-1.49,0L6.38,4.24Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/Sort_Up.eab275b7de9f9a3d2127558a4d26c739.svg";
export { ForwardRef as ReactComponent };